import { ArrowUpRight, Camera } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { TORTE_GALLERY, IMAGES, LINKS } from "@/data/content";

const Galleria = () => (
  <div data-testid="section-galleria" className="mx-auto max-w-md px-5 pb-10 pt-14 sm:max-w-2xl sm:pt-20 lg:max-w-5xl lg:px-8">
    <Reveal>
      <Eyebrow>Le Mie Torte</Eyebrow>
      <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-cacao sm:text-5xl">
        La galleria delle torte
      </h1>
      <p className="mt-3 max-w-lg text-base text-cacao-muted leading-relaxed">
        Alcune delle torte nate nella cucina di Giorgia: ogni ricorrenza
        diventa un'occasione per creare qualcosa di unico.
      </p>
    </Reveal>

    <div className="mt-12 grid gap-5 sm:grid-cols-2">
      {TORTE_GALLERY.map((torta, i) => (
        <Reveal key={torta.id} delay={i * 0.07}>
          <figure
            data-testid={`gallery-card-${torta.id}`}
            className="group overflow-hidden rounded-[1.75rem] border-4 border-white bg-white shadow-[0_18px_45px_rgba(45,36,36,0.1)] transition-all hover:-translate-y-1 hover:shadow-[0_24px_55px_rgba(45,36,36,0.16)]"
          >
            <div className="overflow-hidden">
              <img
                src={IMAGES[torta.image]}
                alt={`${torta.title} — torta decorata a mano da Giorgia Perletta per ${torta.occasion}`}
                className={`aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-105 ${torta.pos || ""}`}
              />
            </div>
            <figcaption className="p-5">
              <p className="font-display text-lg font-bold text-cacao">{torta.title}</p>
              <p className="mt-1 flex items-center gap-1.5 text-sm text-cacao-muted">
                <Camera className="h-3.5 w-3.5 text-rosa" />
                {torta.occasion}
              </p>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.1}>
      <div className="mt-14 rounded-[2rem] border border-pink-100 bg-blush/50 p-8 text-center sm:p-10">
        <h2 className="font-display text-2xl font-bold tracking-tight text-cacao">
          Vuoi creare torte così anche tu?
        </h2>
        <p className="mx-auto mt-2 max-w-md text-sm text-cacao-muted leading-relaxed">
          Nel corso "Torte Perfette Senza Stress" impari basi, coperture e
          decorazioni passo dopo passo.
        </p>
        <a
          data-testid="gallery-hotmart-cta"
          href={LINKS.hotmart}
          target="_blank"
          rel="noopener noreferrer"
          className="group mt-6 inline-flex items-center gap-2 rounded-full bg-hotmart px-8 py-3.5 text-sm font-bold text-white shadow-[0_12px_35px_rgba(230,81,0,0.35)] transition-colors hover:bg-hotmart-dark"
        >
          Scopri il Corso Completo
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </Reveal>
  </div>
);

export default Galleria;
